var map = {
	"./about1.JPG": 6722,
	"./about10.JPG": 15,
	"./about11.JPG": 6191,
	"./about12.JPG": 4616,
	"./about13.JPG": 6710,
	"./about2.JPG": 3233,
	"./about3.JPG": 2072,
	"./about4.JPG": 6639,
	"./about9.JPG": 7736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2217;